<template>
  <main class="d-flex flex-column flex-grow-1 align-items-center justify-content-center bg-primary">
    <section class="container py-3 py-sm-4 d-flex flex-grow-1 align-items-lg-center flex-lg-grow-0 position-relative">
      <div class="col-12 col-dialog px-0 mx-auto mt-5 mt-md-0 position-static text-center">
        <div class="bg-lg-white text-white text-lg-body rounded p-md-4 p-lg-5">
          <logo class="mx-auto d-none d-lg-block mb-lg-5" />
          <logo-white class="mx-auto d-block d-lg-none mb-5" />
          <h1 class="h3 mb-3">Scheduled Maintenance</h1>
          <p class="mb-4">We're currently performing maintenance.<br>Please check back soon.</p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'Maintenance'
}
</script>



// WEBPACK FOOTER //
// src/views/Account/Maintenance.vue